import { Env } from '@stencil/core'
import engResources from './resources.eng'
import testResources from './resources.sat'
import prodResources from './resources.prod'

export type Resource = {
  region: string
  values: string
  autosuggest: string
  querySuggest: string
  coveoAnalytics: string
  profileLink: string
  retailSearchResultsPage: string
  adobeDataLayer: string
  adobeStaging: string
}

const resources: Record<string, Resource> = {
  eng: engResources,
  test: testResources,
  prod: prodResources,
}

export const coveoValuesApiUrl = resources[Env?.region]?.values
export const coveoQuerySuggestApiUrl = resources[Env?.region]?.querySuggest
export const coveoAnalyticsApiUrl = resources[Env?.region]?.coveoAnalytics
export const profileLinkApiUrl = resources[Env?.region]?.profileLink
export const retailSearchResultsPage = resources[Env?.region]?.retailSearchResultsPage
export const adobeDataLayer = resources[Env?.region]?.adobeDataLayer
export const adobeStaging = resources[Env?.region]?.adobeStaging
export const autosuggest = resources[Env?.region]?.autosuggest
